export enum ChatRole {
  AGENT = 'AGENT',
  USER = 'USER',
}

export type ChatMessage = {
  role: ChatRole;
  content: string;
};
